import { Link } from 'solito/link'

import ArrowRightIcon from 'app/assets/icons/arrow-right.svg'
import Box from 'app/components/base/Box'
import Image from 'app/components/base/Image'
import Skeleton from 'app/components/base/Skeleton'
import Stack from 'app/components/base/Stack'
import Text from 'app/components/base/Text'

interface HelpCenterCategoryCardProps {
  link: string
  name: string
  icon: string
  iconAltText?: string
  needBorderRight?: boolean
  hideBorderBottom?: boolean
  isLoading: boolean
}

const HelpCenterCategoryCard = ({
  link,
  name,
  icon,
  iconAltText,
  needBorderRight,
  hideBorderBottom,
  isLoading
}: HelpCenterCategoryCardProps) => {
  return (
    <Box
      sx={{
        display: 'flex',
        minWidth: 202,
        py: { xs: 3, md: 5.5 },
        flex: { xs: 1, md: '0 0 33.33%' },
        justifyContent: { xs: 'space-between', md: 'center' },
        borderBottom: { xs: '1px solid', md: 'none' },
        borderBottomColor: { xs: 'border.main' },
        ...(needBorderRight && {
          borderRight: { xs: 'none', md: '1px solid' },
          borderRightColor: { md: 'border.main' }
        }),
        ...(hideBorderBottom && {
          borderBottom: 'none'
        }),

        '> a': {
          width: { xs: '100%', md: 'auto' }
        }
      }}
    >
      <Skeleton
        loading={isLoading}
        sx={{
          width: { xs: '100%', md: '80%' },
          height: 40,
          textAlign: 'center'
        }}
      >
        <Link href={link}>
          <Stack
            direction="row"
            sx={{
              alignItems: 'center',
              justifyContent: 'space-between',
              width: { xs: '100%', md: 202 }
            }}
          >
            <Stack direction="row" spacing={1} sx={{ alignItems: 'center' }}>
              <Box
                sx={{
                  backgroundColor: 'background.lightGreen',
                  border: '1px solid',
                  borderColor: 'secondary.main',
                  width: 40,
                  height: 40,
                  borderRadius: '50%',
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center'
                }}
              >
                <Box sx={{ width: 24, height: 24 }}>
                  <Image
                    src={icon}
                    width={24}
                    height={24}
                    sizes="32px"
                    alt={iconAltText || `${name}-icon`}
                  />
                </Box>
              </Box>

              <Text
                variant="h5"
                lineClamp={1}
                sx={{ maxWidth: { xs: '100%', md: 140 } }}
              >
                {name}
              </Text>
            </Stack>

            <Box>
              <ArrowRightIcon />
            </Box>
          </Stack>
        </Link>
      </Skeleton>
    </Box>
  )
}

export default HelpCenterCategoryCard
